import { InfoOutlined } from "@mui/icons-material";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";

const Part = ({ title, children }: { title: string; children: string }) => (
  <Box sx={{ mb: 1.25 }}>
    <Typography sx={{ fontSize: 12.5, fontWeight: 700, color: "var(--color-rodeo-black)" }}>
      {title}
    </Typography>
    <Typography sx={{ fontSize: 12.5, color: "var(--color-rodeo-black)", lineHeight: 1.45 }}>
      {children}
    </Typography>
  </Box>
);

/** The "i" beside the page title: how the page is put together, on hover or focus. */
export default function HowThisWorks() {
  return (
    <Tooltip
      arrow
      placement="bottom-start"
      enterTouchDelay={0}
      slotProps={{
        tooltip: {
          sx: {
            maxWidth: 440,
            p: 2,
            background: "var(--color-white)",
            border: "1px solid var(--color-card-border)",
            boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
            fontFamily: "var(--font-lato)",
          },
        },
        arrow: {
          sx: {
            color: "var(--color-white)",
            "&::before": { border: "1px solid var(--color-card-border)" },
          },
        },
      }}
      title={
        <Box>
          <Typography
            sx={{ fontSize: 14, fontWeight: 700, mb: 1, color: "var(--color-rodeo-black)" }}
          >
            How this page works
          </Typography>
          <Part title="What it tracks">
            Subscription fees clients have paid for service GFG has not delivered yet. Each paid
            billing period is released to revenue one month at a time as the service is delivered.
          </Part>
          <Part title="Check against the books (top)">
            What the schedules say is still owed, next to what the accounting books say, as of a
            date (by default the last closed month end). The two should match. If they don't, Review
            differences lists every payment or entry that explains the gap.
          </Part>
          <Part title="Recognition run">
            On the 1st, a run releases the month just ended. The bar under the check says whether it
            ran. If it failed or did not run, Rerun now posts what is waiting; the month can't be
            closed in Periods until it has.
          </Part>
          <Part title="By month">
            One row per month of the fiscal year: owed at start + paid − delivered = owed at end.
            Each month starts where the last one ended. Future months show only what is due to
            release.
          </Part>
          <Part title="By organization">
            The same figures per organization for the year, searchable and sortable. Click a name to
            see its billing periods and every month's release, each linked to its journal entry.
          </Part>
          <Part title="The words">
            Paid: cash received for service still to come. Delivered: released to revenue as each
            month passes. Still owed: paid, not yet delivered.
          </Part>
        </Box>
      }
    >
      <IconButton
        size="small"
        aria-label="How this page works"
        sx={{ color: "var(--color-graphite)" }}
      >
        <InfoOutlined fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
